import store from '@/store'

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
  watch: {
    $route (route) {
      if (this.device === 'mobile' && this.sidebar.opened) {
        store.dispatch('closeSidebar', { withoutAnimation: false })
      }
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.resizeHandler)
  },
  mounted () {
    const isMobile = this.isMobile()
    if (isMobile) {
      store.dispatch('toggleDevice', 'mobile')
      store.dispatch('closeSidebar', { withoutAnimation: true })
    }
  },
  methods: {
    isMobile () {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    resizeHandler () {
      // if (!document.hidden) {
      //   const isMobile = this.isMobile()
      //   store.dispatch('toggleDevice', isMobile ? 'mobile' : 'desktop')
      //
      //   if (isMobile) {
      //     store.dispatch('closeSidebar', { withoutAnimation: true })
      //   }
      // }
    }
  }
}
